import { ShowFlash } from 'ng2/shared/flash/store/flash.actions';

module.exports = {
  bindings: {
    group: '<',
    patientLinked: '&',
    parentPatient: '<',
  },
  templateUrl: 'profile/components/link-patient-form/link-patient-form.html',
  controller: class LinkPatientFormController {

    static $inject =[
      '$ngRedux',
      'LinkedPatients',
      'ProductService',
      'ValidationService',
    ];

    model = {};

    options = {
      gender: {
        required: true,
      },
      name: {
        maxlength: 50,
        required: true,
        trim: true,
      },
      date: {
        required: true,
      },
      hin: {
        required: true,
        years: 10,
      },
      city: {
        maxlength: 255,
        required: true,
        trim: true,
      },
      phone: {
        maxlength: 50,
        required: true,
        trim: true,
      },
      hinExpirationMonth: {
        list: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        required: true,
      },
      hinExpirationYear: {
        list: _.range(moment().year(), (moment().year() + 10)),
        required: true,
      },
      email: {
        required: true,
      },
      password: {
        required: true,
        maxlength: 256,
        minlength: 8,
      },
      contactMethodKinds: ['home', 'mobile', 'work', 'other'],
    };

    linkingError = false;

    constructor($ngRedux, LinkedPatients, ProductService, ValidationService) {
      this.$ngRedux = $ngRedux;
      this.LinkedPatients = LinkedPatients;
      this.ProductService = ProductService;
      this.ValidationService = ValidationService;
    }

    $onInit() {
      this.resetForm();
    }

    hasErrors(ngModel) {
      return ngModel.$$parentForm.$submitted && ngModel.$invalid;
    }

    submit() {
      this.linkingError = false;

      this.model.$post((resource) => {
        this.patientLinked({ patient: resource });
        this.resetForm();
      }, (error) => {
        if (error.status === 404) {
          this.linkingError = 'notFound';
        } else if (error.status === 400) {
          switch (error.data.error.subcode || error.data.error) {
            case 'api.errors.cant_link_self':
            case 'cant_link_self':
              this.linkingError = 'self';
              break;
            case 'api.errors.already_linked':
            case 'already_linked':
              this.linkingError = 'alreadyLinked';
              break;
            case 'api.errors.no_match':
              this.linkingError = 'noMatch';
              break;
            case 'api.errors.already_confirmed':
            case 'already_confirmed':
              this.linkingError = 'alreadyConfirmed';
              break;
            default:
              this.linkingError = 'notFound';
              break;
          }
        } else {
          this.$ngRedux.dispatch(new ShowFlash({ name: 'error' }));
        }
      });
    }

    resetForm() {
      if (this.form) {
        this.form.$setPristine();
      }

      this.model = new this.LinkedPatients({
        patientId: this.parentPatient.id,
        groupId: this.group.id,
        manitoba: this.hasManitobaProduct(),
      });

      this.linkingError = false;
    }

    onHinKeyDown(event) {
      return this.ValidationService.doHinValidation(event, this.group.validateHin, this.model, this.form, this.hasManitobaProduct());
    }

    onHinChanged() {
      this.ValidationService.validateHin(this.form.hin.$viewValue, this.model, this.hasManitobaProduct());
    }

    onHinExpiryChange() {
      const hasError = this.ValidationService.validateHinExpiryDate(this.form.hinExpirationMonth.$viewValue, this.form.hinExpirationYear.$viewValue)
      this.form.hinExpirationMonth.$setValidity('match', hasError);
    }

    validateHinExpiration() {
      return this.group && this.group.validateHinExpiration;
    }

    hasManitobaProduct() {
      return this.ProductService.isAvailable('MANITOBA_BOOKING');
    }

    hasGenericHinProduct() {
      return this.ProductService.isAvailable('GENERIC_PHN');
    }

    get showExtraFields() {
      return this.ProductService.isAvailable('PATIENT_CREATION_ON_LINK');
    }

    get otherGenderAllowed() {
      return this.ProductService.isAvailable('OTHER_PATIENT_GENDER');
    }

    get hinMessageSuffix() {
      return this.hasManitobaProduct() || this.hasGenericHinProduct() ? 'phin' : 'hin';
    }
  },
};



// WEBPACK FOOTER //
// ./profile/components/link-patient-form/link-patient-form.js